import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Config } from '../../data-models/config.interfaces';

export type AppConfigMap = { [key: string]: Config };

export interface HttpHeadersPayload {
  [name: string]: string | string[];
}

export type HttpErrorHandler = (
  error: HttpErrorResponse,
  appName: string,
  library: string,
  endpointKey: string
) => Observable<never>;

export interface ReplaceItem {
  src: string;
  target: string;
}
